/* eslint-disable */
export function scrollTo(to, duration, callback) {
  const start = window.scrollY || window.pageYOffset;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = function animateScroll() {
    currentTime += increment;
    // var val = Math.easeInOutQuad(currentTime, start, change, duration);
    window.scrollTo(0, Math.easeInOutQuad(currentTime, start, to, duration));
    if(currentTime < duration) {
      setTimeout(animateScroll, increment);
    } else {
      if (callback) {
        callback();
      }
    }
  };
  animateScroll();
}

// t = current time
// b = start value
// c = change in value
// d = duration
Math.easeInOutQuad = function easeInOutQuad(t, b, c, d) {
  t /= d/2;
  if (t < 1) return c/2*t*t + b;
  t--;
  return -c/2 * (t*(t-2) - 1) + b;
};



/*
* Outputs a float representing the iOS version if user is using an iOS browser i.e. iPhone, iPad
* Possible values include:
* 3 - v3.0
* 4.0 - v4.0
* 4.14 - v4.1.4
* false - Not iOS
*/

export const isIOS = parseFloat(
  ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')
) || false;


export const isFF = /firefox/i.test(navigator.userAgent);

export function addEventListenerOnce(target, type, listener) {
  const onceFn = function onceFn () {
    target.removeEventListener(type, onceFn);
    listener(event);
  };
  target.addEventListener(type, onceFn);
}



/* https://stackoverflow.com/a/4770179/440791 */
function preventDefault(e) {
  e = e || window.event;
  if (e.preventDefault)
    e.preventDefault();
  e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

export function disableScroll() {
  if (window.addEventListener) // older FF
    window.addEventListener('DOMMouseScroll', preventDefault, false);
  window.onwheel = preventDefault; // modern standard
  window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
  window.ontouchmove  = preventDefault; // mobile
  document.onkeydown  = preventDefaultForScrollKeys;
}

export function enableScroll() {
  if (window.removeEventListener)
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
  window.onmousewheel = document.onmousewheel = null;
  window.onwheel = null;
  window.ontouchmove = null;
  document.onkeydown = null;
}

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/javascript/main/Utils.js